// removed by extract-text-webpack-plugin
module.exports = {"AppointmentButton":"AppointmentButton__AppointmentButton___Wokcp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Appointment/AppointmentButton/AppointmentButton.scss
// module id = 1345
// module chunks = 0